var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageFirstIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50003 7C9.05232 7 9.50003 7.44772 9.50003 8V16C9.50003 16.5523 9.05232 17 8.50003 17C7.94775 17 7.50003 16.5523 7.50003 16V8C7.50003 7.44772 7.94775 7 8.50003 7ZM15.0332 7.24414C15.368 6.91876 15.9114 6.91878 16.2461 7.24414C16.5808 7.56949 16.5807 8.09745 16.2461 8.42285L12.5694 12L16.2491 15.5771C16.5835 15.9025 16.5836 16.4305 16.2491 16.7559C15.9143 17.0812 15.3709 17.0811 15.0362 16.7559L10.751 12.5908C10.4164 12.2655 10.4165 11.7375 10.751 11.4121L10.7481 11.4092L15.0332 7.24414Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageFirstIco);
export default __webpack_public_path__ + "static/media/Page_first_ico.07f20d52a729d22c0b7c1fff268da7fa.svg";
export { ForwardRef as ReactComponent };